import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import ServiceSection from './components/ServiceSection';
import FeaturesSection from './components/FeaturesSection';
import ResultsSection from './components/ResultsSection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import SEOJsonLd from './components/SEOJsonLd';

export default function HomePage() {
  return (
    <div className="min-h-screen overflow-x-hidden">
      <SEOJsonLd />
      <Navbar />
      <main>
        <HeroSection />
        <ProblemSection />
        <ServiceSection />
        <FeaturesSection />
        <ResultsSection />
        <PricingSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
